import { Box, makeStyles, Theme } from "@material-ui/core";
import { observer } from "mobx-react";
import { formatCurrency } from "@roc/ui/utils";
import { PayoffCardRow } from "./payoffCardRow";
import { PayoffCardColumn } from "./payoffCardColumn";
import { PayoffCardColumnHeaderText } from "./payoffCardColumnHeaderText";
import { PayoffCardCellText } from "./payoffCardCellText";
import { PayoffCardTotalRow } from "./payoffCardTotalRow";
import { PayoffCardTotalCellText } from "./payoffCardTotalCellText";
import { PayoffCardAccordionRow } from "./payoffCardAccordionRow";
import { isNil, formatDate, DateFormat } from "@roc/feature-utils";

const useStyles = makeStyles((theme: Theme) => ({
  borderColor: {
    borderColor: theme.palette.primary.main,
  },
  headerStyle: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.getContrastText(theme.palette.primary.main),
    borderColor: theme.palette.primary.main,
  }
}));

export const PayoffCard = observer(({ columns, rows, total, compactView = false }) => {
  const classes = useStyles();

  const getColumn = (column, children = undefined) => {
    return (
      <PayoffCardColumn width={column?.width ?? `${100 / columns.length}%`} textAlign={column?.type === 'currency' ? 'right' : 'left'}>
        {children}
      </PayoffCardColumn>
    )
  }

  const getCellValue = (column, row) => {
    const value = row[column?.value];
    if (isNil(value)) {
      return '-';
    }
    if (column?.type === 'date') {
      return formatDate(value, DateFormat.MMDDYYYY);
    }
    if (column?.type === 'currency') {
      return formatCurrency(value);
    }
    return value;
  }

  const getRowDetails = () => {
    return (
      <>
        {rows?.length > 0 ?
          rows?.map(row => (
            <PayoffCardRow>
              {columns?.map(column =>
                getColumn(column, <PayoffCardCellText>{getCellValue(column, row)}</PayoffCardCellText>)
              )}
            </PayoffCardRow>
          ))
          :
          <PayoffCardRow>
            {getColumn(columns[0], <PayoffCardCellText>No Records.</PayoffCardCellText>)}
          </PayoffCardRow>
        }
      </>
    );
  }

  return (
    <Box style={{ padding: '0px 16px 16px' }} >
      <PayoffCardRow >
        {columns?.map(column =>
          getColumn(column, <PayoffCardColumnHeaderText>{column?.label}</PayoffCardColumnHeaderText>)
        )}
      </PayoffCardRow>
      {compactView && rows.length > 5 ?
        <PayoffCardAccordionRow
          isOpen={false}
        >
          <Box display="flex" justifyContent="left" style={{ width: '98%' }}>
            {getColumn(columns[0], <PayoffCardCellText>Details</PayoffCardCellText>)}
          </Box>
          {
            <Box justifyContent="left" style={{ width: '100%' }}>
              {getRowDetails()}
            </Box>
          }
        </PayoffCardAccordionRow>
        :
        getRowDetails()
      }
      <PayoffCardTotalRow >
        <PayoffCardColumn width='50%' textAlign='left'>
          <PayoffCardTotalCellText>Total</PayoffCardTotalCellText>
        </PayoffCardColumn>
        <PayoffCardColumn width='50%' textAlign='right'>
          <PayoffCardTotalCellText>{!isNil(total) ? formatCurrency(total) : '-'}</PayoffCardTotalCellText>
        </PayoffCardColumn>
      </PayoffCardTotalRow>
    </Box>
  );
});